<!--
    T34, r13 point 12: the footer is one row -- the year and © Asset Flow. at the left, the version at
    the right, the version still only when `window.afAppVersion` is set. Eleven words, and that is the
    whole footer of the product. Nothing is added to it: no links, no legal line, no support route.

    `ftd` is on the <footer> ELEMENT and not on a wrapper round it. The site's `.footer` is
    `position: absolute` (`_footer.scss:5-13`), and `.ftd` is a size container, so a wrapper would
    become the footer's containing block and tear it off the foot of the page. `_topbar.scss` writes
    this one rule for both shapes of the selector because of it.
-->
<template>
  <footer class="footer ftd ftd-r13-foot">
    <span>{{ new Date().getFullYear() }} © Asset Flow.</span>
    <span v-if="version" class="ftd-r13-foot__ver">Version {{version}}</span>
  </footer>
  <!-- end footer -->
</template>

<script>
export default {
  data() {
    return {
      version: window.afAppVersion || ''
    };
  }
};
</script>